import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41e69ab4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "area-icon"
}
const _hoisted_2 = { class: "area-number" }
const _hoisted_3 = { class: "area-desc" }

import { withDefaults } from 'vue';
import { ShieldDoneIcon } from '@/components/atoms';

interface IProps {
  description: string;
  number: string | number;
  classes?: string[];
  noBorder?: boolean;
  hasIcon?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomInfoCard',
  props: {
    description: null,
    number: null,
    classes: null,
    noBorder: { type: Boolean },
    hasIcon: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { description: string, number: string | number, classes?: string[], noBorder?: boolean, hasIcon: boolean };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[__props.noBorder ? '' : 'border-r'], "area-info"])
  }, [
    (__props.hasIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "icon")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.number), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.description), 1)
  ], 2))
}
}

})